import { AppConfig, Menu } from "./interfaces/app-config";

export var globalConfig: AppConfig = {
  production: false,
  logo: '/assets/img/logo.svg',
  logoSVG: '/assets/img/logo.svg',
  metadata: {
    title: 'Solunes Digital',
    subtitle: 'Soluciones Digitales',
    description: 'Soluciones Digitales',
    keywords: 'soluciones digitales, software, desarrollo web, aplicaciones móviles',
    favicon: '/assets/img/favicon/favicon.ico',
  },
  colors: {
    primary: '#070B25',
    secondary: '#009ed1',
    tertiary: '#4c98bf',
  },
  fonts: {
    title: 'Rubik',
    subtext: 'Montserrat',
    text: 'Roboto',
  },
  styles: "@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&family=Rubik:ital,wght@0,300..900;1,300..900&display=swap');",

  authRedirect: '',

  // Seats IO
  region: 'sa',

  keyEncript: '3fa85f64c2f9e0c53fa85f64c2f9e0c5',
  ivEncript: 'c2f9e0c53fa85f64',

  yearProyect: 2025,

  keyRecaptcha: null,
  menu: [
    Menu.create({
      id: 2,
      path: '/home',
      title: 'Comprar',
    }),
    Menu.create({
      id: 3,
      path: '/tickets-saved',
      title: 'Mis Tickets',
    }),
  ],
  mobileMenu: [
    Menu.create({
      id: 1,
      path: '/home',
      title: 'Comprar',
      icon: '/assets/icons/home_white.svg',
      iconType: 'img'
    }),
    Menu.create({
      id: 3,
      path: '/tickets-saved',
      title: 'Mis Compras',
      icon: '/assets/icons/ticket_white.svg',
      iconType: 'img'
    }),
  ],
  footerMenu: [
    {
      id: 1,
      title: 'Páginas',
      menu: [
        Menu.create({
          id: 2,
          path: '/privacy-policy',
          title: 'Términos y Condiciones',
          external: false,
        }),
      ]
    }
  ],
  staticMap: false,
  keyMap: 'AIzaSyCbWR6PgxPfBaPOgwkV0QRvvXhwxSDFyaM',
  authGoogle: true,
  authGuest: false,
  appleWallet: false,
  googleWallet: false,
  underConstruction: null,
  currency: 'Bs',
  gtmId: null,
  zendeskKey: null,
  facebookPixelKey: null,
  bgDarkRoutes: [],
  bgCustomRoutes: [],
  pages: {
    login: {
      title: 'Inicia sesión en tu cuenta',
      subtitle: '¡Bienvenido! Por favor, ingresa tus datos.',
      form: {
        email: {
          label: 'Correo electrónico',
          placeholder: 'Ingresa tu correo electrónico'
        },
        password: {
          label: 'Contraseña',
          placeholder: 'Ingresa tu contraseña'
        },
        rememberMe: {
          label: 'Recordarme'
        },
      },
      forgotPassword: '¿Olvidaste tu contraseña?',
      submit: 'Iniciar sesión',
      nextAuth: {
        question: '¿No tienes una cuenta?',
        action: 'Registrate'
      }
    },
    register: {
      title: 'Crea tu cuenta',
      subtitle: 'Por favor, ingresa los datos requeridos',
      form: {
        name: {
          label: 'Nombre completo',
          placeholder: 'Ingresa tu nombre completo'
        },
        email: {
          label: 'Correo electrónico',
          placeholder: 'Ingresa tu correo electrónico'
        },
        phone: {
          label: 'Teléfono celular',
          placeholder: 'Ingresa tu celular'
        },
        city: {
          label: 'Ciudad',
          placeholder: 'Selecciona tu ciudad'
        },
        credential: {
          label: 'Número de identificación',
          placeholder: 'Ingresa tu identificación'
        },
        password: {
          label: 'Contraseña',
          placeholder: 'Ingresa tu contraseña'
        },
        repeatPassword: {
          label: 'Repite la contraseña',
          placeholder: 'Repide tu contraseña'
        },
      },
      submit: 'Registrarse',
      nextAuth: {
        question: '¿Ya tienes una cuenta?',
        action: 'Inicia sesión'
      }
    },
    payment: {
      invoiceTitle: 'Detalles de facturación',
      invoiceName: 'Razón Social',
      invoiceType: 'Tipo de documento',
      invoiceNumber: 'Número de documento',
      email: 'Email',
    },
    general: {
      serviceFee: 'Service Fee',
      total: 'Total',
    },
    paymentSuccess: {
      title: 'Detalles del evento',
      subtitle: 'Evento',
      date: 'Fecha y hora',
      location: 'Ubicación del evento',
      organizer: 'Organizador del evento',
      itemsTitle: 'Entradas',
      paymentMethod: 'Método de pago',
      orderId: 'ID de la orden',
      status: 'Estado',
      downloadTicket: 'Descargar ticket',
      backToHome: 'Volver a inicio',
    },
    search: {
      title: 'Buscar eventos',
    },
    ticket: {
      buyTickets: 'Comprar Tickets',
      date: 'Elige tu fecha para el evento',
      hour: 'Elige tu horario para el evento',
      noDataDates: 'No hay horarios disponibles',
      duration: 'Duración del evento',
      dateTime: 'Fecha(s) y hora(s) del evento',
      age: 'Edad',
      location: 'Ubicación',
      continue: 'Continuar',
      selectDate: 'Fecha',
      eventTag: 'SKU#',
      price: 'Precio',
      tabInformation: 'Información',
      tabAddress: 'Dirección',
      tabMap: 'Mapa',
    },
    ticketsSaved: {
      title: 'Mis Tickets',
      tabActive: 'Activos',
      tabHistory: 'Historial',
      information: '<p>Con tu sesión iniciada guardarás todos tus tickets comprados en esta vista, ingresa a cada uno para descargar los tickets que serán las entradas a tu evento. </p><p>Importante: No compartas tu acceso al sistema y tampoco las imágenes QRs de tus entradas.</p>',
      noDataActive: 'Accede fácilmente a tus tickets activos en esta sección',
      noDataHistory: 'Accede fácilmente a tu historial de compras en esta sección',
      tickets: 'Tickets',
    }
  },
  validations: {
    required: "El campo \"{label}\" es requerido.",
    number: "El campo \"{label}\" debe contener solo números.",
    minlength: "El campo \"{label}\" debe tener al menos \"{requiredLength}\" caracteres.",
    maxlength: "El campo \"{label}\" debe tener un máximo de \"{requiredLength}\" caracteres.",
    min: "El campo \"{label}\" debe contener al menos \"{min}\" elementos.",
    max: "El campo \"{label}\" debe tener un máximo de \"{max}\" elementos.",
    email: "El campo \"{label}\" debe ser un email válido.",
    default: "El campo \"{label}\" es inválido.",
  },
  registerForm: {
    first_name: true,
    last_name: true,
    email: true,
    password: true,
    country_identity: true,
    birth_date: true,
    city_id: true,
    cellphone: true,
  },
  formatDecimalAndMillion: {
    thousandsSeparator: '.',
    decimalSeparator: ',',
    autoDecimal: true,
    forceDecimal: false,
    minDecimalPlaces: 0,
    maxDecimalPlaces: 2
  },
  organizator: 'Todotix',
  filters: true,
  // filters: false,
};
